import { useTranslation } from 'react-i18next';
import PageHeader from '../../../../Components/Shared/PageHeader';
import EnrollmentStudentAndParentsForm from '../EnrollmentStudentAndParentsForm';
import NewEnrollmentInformationForm from './NewEnrollmentInformationForm';

const StudentInformation = ({
  studentForm,
  enrollmentForm,
  marketplaceChildId,
  setInterestedFamily,
  desiredStartDate,
  defaultRoomId,
  scheduledDays,
  onSaveSchedule,
  parents,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader pageName={t('students.addStudentPageTitle')} classes="add-student-page" />
      <h1 className="mb-4 text-2xl font-bold">{t('students.addStudentPageTitle')}</h1>
      <div className="mb-6 rounded-md border-2 border-gray-300 bg-gray-50 p-4">
        <EnrollmentStudentAndParentsForm
          form={studentForm}
          marketplaceChildId={marketplaceChildId}
          onInterestedFamilySelected={(interestedFamilyLocal) => {
            setInterestedFamily(interestedFamilyLocal);
          }}
          parents={parents}
        />
      </div>
      <div className="mb-6 rounded-md border-2 border-gray-300 bg-gray-50 p-4">
        <NewEnrollmentInformationForm
          form={enrollmentForm}
          desiredStartDate={desiredStartDate}
          desiredRoomId={defaultRoomId}
          scheduledDays={scheduledDays}
          isSavingSchedule={false}
          onSaveSchedule={onSaveSchedule}
        />
      </div>
    </>
  );
};

export default StudentInformation;
